import { memo } from 'react';

import Divider from '@zenbusiness/zui/Divider';
import LoadingButton from '@zenbusiness/zui/LoadingButton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { NEEDS_REVIEW_STATUSES } from '#client/constants/transaction';

import CheckDepositNeedReviewRow from './CheckDepositNeedReviewRow';
import CheckDepositRow from './CheckDepositRow';

function ListCheckDeposit({
  title,
  checkDeposits,
  isLoading = false,
  hasMore = false,
  handleLoadMore
}) {
  const checkDepositRows = checkDeposits.map(
    ({
      id,
      type,
      status,
      summary,
      amount,
      createdAt,
      estimatedCompletionDate,
      transactionId,
      reason,
      balance
    }) => {
      if (NEEDS_REVIEW_STATUSES.includes(status)) {
        return (
          <CheckDepositNeedReviewRow
            createdAt={createdAt}
            id={id}
            key={id}
            summary={summary}
          />
        );
      }

      return (
        <CheckDepositRow
          amount={amount.formattedAmount}
          balance={balance}
          createdAt={createdAt}
          estimatedCompletionDate={estimatedCompletionDate}
          id={id}
          key={id}
          reason={reason}
          status={status}
          summary={summary}
          transactionId={transactionId}
          type={type}
        />
      );
    }
  );

  return (
    <Stack
      aria-label="List of deposit"
      direction="column"
      paddingBottom="20px"
      role="list"
    >
      <Stack
        direction="column"
        spacing="8px"
      >
        <Text
          color="secondary"
          size="xs"
          uppercase
          weight="medium"
        >
          {title ?? 'All Transactions'}
        </Text>
        <Divider />
        <Stack
          direction="column"
          spacing="8px"
        >
          {checkDepositRows}
        </Stack>
      </Stack>
      {hasMore && (
        <Stack
          direction="row"
          justifyContent="center"
          pt="40px"
          spacing="8px"
        >
          <LoadingButton
            disabled={isLoading}
            loading={isLoading}
            onClick={handleLoadMore}
            variant="outlined"
          >
            Load more
          </LoadingButton>
        </Stack>
      )}
    </Stack>
  );
}

ListCheckDeposit.propTypes = {
  title: PropTypes.string,
  checkDeposits: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      depositTo: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      summary: PropTypes.string.isRequired,
      balance: PropTypes.string,
      amount: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        formattedAmount: PropTypes.string.isRequired
      }).isRequired,
      createdAt: PropTypes.string,
      estimatedCompletionDate: PropTypes.string,
      transactionId: PropTypes.string,
      reason: PropTypes.string,
      method: PropTypes.string
    })
  ).isRequired,
  isLoading: PropTypes.bool,
  hasMore: PropTypes.bool,
  handleLoadMore: PropTypes.func
};

function areEqual(preProp, nextProp) {
  return (
    preProp.isLoading === nextProp.isLoading && preProp.checkDeposits === nextProp.checkDeposits
  );
}

export default memo(ListCheckDeposit, areEqual);
